import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import chartHelper from '../util/chartFormatter'
import ListErrors from './widgets/ListErrors'
import { Link } from 'react-router-dom'
import {
  LOGIN,
  LOGIN_PAGE_UNLOADED,
  REDIRECT
} from '../constants/actionTypes'
import { REACT_APP_BASE_COIN_SYMBOL } from '../constants/config'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

const mapStateToProps = state => ({
  ...state.auth,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: () => {
  },
  onSubmit: (payload) =>
    dispatch({ type: LOGIN, payload }),
  onUnload: () =>
    dispatch({ type: LOGIN_PAGE_UNLOADED }),
})

class Login extends React.Component {
  constructor() {
    super()
    this.state = {
      email: '',
      password: ''
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    }
    this.submitForm = (email, password) => ev => {
      ev.preventDefault()
      const payload = agent.Auth.login(email, password)
      this.props.onSubmit(payload)
    }
  }
  componentWillMount() {
  }

  componentWillUnmount() {
    this.props.onUnload();
  }
  render() {
    const email = this.state.email
    const password = this.state.password
    return (
      <Translation>
        {
          (t) => (
            <div id="focus">
              <div id="focus-header"><h1>{t('system.name')}</h1></div>
              <div className="main">
                <div className="main-wrap">
                  <div className="focus-wrap">
                    <div className='box-header'>
                      <h2>{t('authentication.login_title')}</h2>
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.email')}</label>
                      <input type="text" placeholder="john@smith.com" value={email} onChange={this.updateState('email')} />
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.password')}</label>
                      <input type="password" value={password} onChange={this.updateState('password')} />
                    </div>
                    <ListErrors errors={this.props.errors} />
                    <div className="form-item">
                      <button onClick={this.submitForm(email, password)}>{this.props.inProgress ? t('authentication.login_button_progress') : t('authentication.login_button')}</button>
                    </div>
                    <div className="form-item form-rule">
                      <em className='auth-hint'>{t('authentication.register_prompt_start')}</em><br />
                      <Link className='light-button' to="/register" >{t('authentication.register_prompt_end')}</Link>
                    </div>
                    <div className="form-item form-rule">
                      <Link className='auth-prompt' to="/restpassword"><em>{t('authentication.forgot_password_prompt')}</em></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </Translation >
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
